import { render, staticRenderFns } from "./CustomerInfoStep.vue?vue&type=template&id=5e957773&"
import script from "./CustomerInfoStep.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoStep.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfoStep.vue?vue&type=style&index=0&id=5e957773&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports